import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import generator from 'generate-password';
import Select from 'react-select';
import axios from 'axios';
import { kinetik_api_url } from '../../utilities/const';

class CreateUserModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            userTypes: [
                { label: 'Manager', value: '2' },
                { label: 'Standard', value: '3' }
            ],
            selectedUserType: {}
        };

    }

    handleUserType = (selected) => {
        this.setState({
            selectedUserType: selected
        })
    }

    createNewUser = () => {
        let first_name =  document.getElementById('first_name').value;
        let last_name =  document.getElementById('last_name').value;
        let user_email =  document.getElementById('user_email').value;
        var password = generator.generate({
            length: 10,
            numbers: true
        });

        if (first_name !== '' && user_email !== '' && last_name !== '' && this.state.selectedUserType.value) {
            let URL = kinetik_api_url + '/register_in_system';

            axios.post(URL, {
                email: user_email,
                password,
                firstName: first_name,
                lastName: last_name,
                userType: this.state.selectedUserType.value,
                token: localStorage.getItem('authToken')
            })
            .then( (result) => {
                window.alert(result.data.message);
                if(result.data.status === 'success'){
                    this.props.hideOrShowEditingModal();
                    this.props.onUserCreated();
                }
            })
            .catch( (err) => {
                console.log(err);
            })
        } else {
            window.alert("Please fill out required fields to create new User");
        }
    }
    render(){
        return(
            <div>
                <Modal show={this.props.show} onHide={this.props.hideOrShowEditingModal} className="userEdit_m">
                    <Modal.Header className="boarding_header_wrapper user_editing_h">
                        <Modal.Title>
                            <div className="boarding_modal_header user_editing_t">
                                <h3>Add New User</h3>
                                <span>Add New User to System</span>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="brd_tab_cntnt settings_page_profile">
                                    <div className="brding_frm_ele">
                                        <span>First Name</span>
                                        <input id="first_name" type="text" placeholder="First Name" />
                                    </div> <br />
                                    <div className="brding_frm_ele">
                                        <span>Last Name</span>
                                        <input id="last_name" type="text" placeholder="Last Name" />
                                    </div> <br />
                                    <div className="brding_frm_ele">
                                        <span>User Email</span>
                                        <input id="user_email" type="text" placeholder="User Email" />
                                    </div> <br />
                                    <div className="brding_frm_ele">
                                        <span>User Type</span>
                                        <Select 
                                            clearable={false}
                                            disabled={false}
                                            className="edit_user_type"
                                            options={this.state.userTypes}
                                            value={this.state.updateVal}
                                            onChange={this.handleUserType}

                                        />
                                    </div> <br />
                                    <div className="brding_frm_ele">
                                        <span className="user_c_modal_a_title">Admin - </span>
                                        <p className="user_c_modal_a_con">Has access to all features of the app. Can edit,
                                            delete and add new users and can control their activities.
                                        </p>
                                    </div> <br />
                                    <div className="create_user_m_btn_">
                                        <input onClick={this.createNewUser} type="submit" className="settings_update_btn_signup" id="submit_box_signuop" value="Add User" />
                                    </div><br />
                                    <div className="cancel_btn_user_create">
                                        <h5 onClick={this.props.hideOrShowEditingModal}>Cancel</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
 export default CreateUserModal;


// WEBPACK FOOTER //
// ./src/app/profile_settings/users/createUserModal.js